
import { PatientControllerApi, PatientCredentialControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

type Param = {
    patientId: string;
    xTENANTID?: string;
}

/**
 *
 * @author Rajkumar Rathod
 */
export const useCreatePatientCredential = () =>
    useMutationWithLoading(
        async (params: Param) =>
            new PatientCredentialControllerApi(
                getConfigObject()
            ).generateCredential(
                params?.patientId,
                params?.xTENANTID
            )
    );

export const useGetPatientCred = () =>
    useMutationWithLoading(
        async (params: Param) =>
            new PatientCredentialControllerApi(
                getConfigObject()
            ).getCredential(
                params?.patientId,
                params?.xTENANTID
            )
    );


export const useCreatePatientSendCredentialOnEmail = () =>
    useMutationWithLoading(
        async (params: Param) =>
            new PatientCredentialControllerApi(
                getConfigObject()
            ).sendCredentialEmail(
                params?.patientId,
                params?.xTENANTID
            )
    );

export const useEnableDisablePatientPortal = () =>
    useMutationWithLoading(
        async (params: Param & { access: boolean }) =>
            new PatientControllerApi(
                getConfigObject()
            ).updatePatientPortalAccess(
                params?.patientId,
                params?.access,
                params?.xTENANTID
            )
    );
